import { InstallPWA } from '../../Widgets';
import React, { useState } from 'react';
import { useDispatch } from "react-redux";
import ArthaGateway from 'service/ArthaGateway';
import { ActionCreators } from 'store/actionCreators';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightToBracket } from '@fortawesome/free-solid-svg-icons';
import { app_version, clearCache } from 'service/Utils';
import logo from "../../../assets/logo.png"
import { AuthSession } from 'service/AuthSession';

export const Login = () => {    
    const [companyCode, setCompanyCode] = useState<string>("");
    const [username, setUsername] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [isValidating, setIsValidating] = useState<boolean>(false);
    const dispatch = useDispatch();

    const validateLogin = () => {
        setIsValidating(true);
        ArthaGateway
        .validateLogin(companyCode, username, password)
        .then(async (data) => {
            const user = {
                userName: data.name,
                name: data.name,
                profile: data
            };
            await AuthSession.save(user);
            dispatch(ActionCreators.login(user));            
            setIsValidating(false);
            setTimeout(() => window.location.href = "/", 500);
        })
        .catch(error => {
            console.log(error);
            setShowAlert(true);
            setUsername("");
            setPassword("");
            setTimeout(() => setShowAlert(false), 10000);
            setIsValidating(false);
        });
    };
    
    const canLogin = (companyCode.length > 0) && (password.length > 0) && (username.length > 0);

    return (
        <div className='auth-page'>
            <div className='auth-shell'>
                <InstallPWA />
                <form className='auth-card' onSubmit={(e) => { e.preventDefault(); if (canLogin && !isValidating) { validateLogin(); } }}>
                    {showAlert &&
                        <div className="alert alert-danger" role="alert">
                            The credentials you entered does not match with any of the records.
                        </div>
                    }
                    <div className="auth-logo">
                        <img src={logo} width="150" alt="Artha" />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Company Code</label>
                        <input type="text" className="form-control" value={companyCode} onChange={(e) => setCompanyCode(e.target.value)} maxLength={10} />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Username</label>
                        <input type="text" className="form-control" value={username} onChange={(e) => setUsername(e.target.value)} maxLength={10} />
                    </div>
                    <div className="mb-3">
                        <label className="form-label" >Password</label>
                        <input type="password" className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    <button type='submit' className='btn btn-dark w-100' disabled={!canLogin || isValidating}>
                        {isValidating &&
                            <div className="spinner-border spinner-border-sm text-light" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        }
                        {!isValidating &&
                            <>
                                <FontAwesomeIcon icon={faRightToBracket} style={{ marginRight: 10 }} />
                                Login
                            </>
                        }
                    </button>
                    <div className='auth-footer'>
                        <div className="btn btn-sm btn-outline-dark" onClick={clearCache}>Update to latest version</div>
                        <span>{app_version}</span>
                    </div>
                </form>
            </div>
        </div>
    );
};